<template>
    <nio-dropdown :placement="placement">
        <template #trigger>
            <button class="link-gray | inline-flex items-center" tabindex="-1">
                {{ $t('appointments.sendConfirmationModal.placeholders') }}
                <nio-icon class="ml-2 text-xs" name="regular/arrow-down-1" />
            </button>
        </template>

        <nio-dropdown-item
            :key="attribute"
            @click="selectAttribute(attribute)"
            v-for="attribute in templatesAttributes"
        >
            {{ attribute }}
        </nio-dropdown-item>
        <hr v-if="additionalAttributes.length">
        <nio-dropdown-item
            :key="attribute"
            @click="selectAttribute(attribute)"
            v-for="attribute in additionalAttributes"
        >
            {{ attribute }}
        </nio-dropdown-item>
    </nio-dropdown>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        props: {
            additionalAttributes: {
                type: Array,
                default: () => [],
            },
            placement: {
                type: String,
                default: 'bottom-end',
            },
        },

        computed: {
            ...mapGetters([
                'templatesAttributes',
            ]),
        },

        methods: {
            selectAttribute(attribute) {
                this.$emit('insert', `{ ${attribute} }`);
            },
        },
    };
</script>
